import { cn } from '@/lib'

interface PingProps extends React.ComponentProps<'div'> {}
export const Ping: React.FC<PingProps> = ({ className, ...props }) => {
  return (
    <div className={cn('absolute -right-1 -top-1 size-3 zoom-in-50', className)} {...props}>
      <div className='relative flex items-center justify-center'>
        <span className='absolute inline-flex size-3 rounded-full bg-green-100 opacity-75 animate-ping'></span>
        <span className='relative inline-flex size-3 rounded-full bg-green-100'></span>
      </div>
    </div>
  )
}
